module.exports = __webpack_public_path__ + "img/20200515_161632.e79385bf.jpg";